import { useState } from "react";

import { BlocksProvider, LayersProvider } from "@grapesjs/react";
import {
  Box,
  SegmentedControl,
  SegmentedControlProps,
  Stack,
} from "@mantine/core";

import { CustomBlockManager } from "./block-manager/CustomBlockManager";
import { CustomLayerManager } from "./layer-manager/CustomLayerManager";

export const BuilderLeftSidebar = () => {
  const [activeTab, setActiveTab] = useState("blocks");

  return (
    <Box
      sx={{
        flexShrink: 0,
        width: 256,
        background: "var(--var-builder-panel-color)",
        borderRight: "1px solid var(--mantine-color-gray-3)",
        maxHeight: "100%",
      }}
    >
      <Stack px={"sm"} spacing={"sm"}>
        <Box
          py={"xs"}
          sx={{
            borderBottom: "1px solid var(--mantine-color-gray-3)",
          }}
        >
          <PrettySegmentedControl
            fullWidth
            value={activeTab}
            onChange={setActiveTab}
            radius={"sm"}
            data={[
              { label: "Blocks", value: "blocks" },
              { label: "Layers", value: "layers" },
            ]}
          />
        </Box>
        {activeTab === "blocks" && (
          <BlocksProvider>
            {(props) => <CustomBlockManager {...props} />}
          </BlocksProvider>
        )}
        {activeTab === "layers" && (
          <LayersProvider>
            {(props) => <CustomLayerManager {...props} />}
          </LayersProvider>
        )}
      </Stack>
      {/* <TraitsProvider>
          {(props) => <CustomTraitManager {...props} />}
        </TraitsProvider>
  
        <StylesProvider>
          {(props) => <CustomStyleManager {...props} />}
        </StylesProvider>
   */}
    </Box>
  );
};

export const PrettySegmentedControl = (props: SegmentedControlProps) => {
  return (
    <SegmentedControl
      styles={{
        root: {
          backgroundColor: "var(--mantine-color-gray-3)",
        },
        active: {
          backgroundColor: "var(--mantine-color-white)",
          height: "34px !important",
        },
        labelActive: {
          backgroundColor: "transparent",
        },
        control: {
          backgroundColor: "transparent !important",
        },
      }}
      {...props}
    />
  );
};
